/**
 * Associates every select filter's key with the list of options it offers.
 *
 * A select filter declared in `FilterConfig` but missing from this map still renders — the control
 * appears and its dropdown comes up empty, with nothing failing anywhere. That is how the Priority
 * filter shipped unusable: its declaration was complete and tested, and the only thing missing was
 * one line here.
 *
 * It lives beside `FilterConfig`, which declares the keys this map has to cover, rather than inside
 * the table component that consumes it: the association is configuration, not rendering, and keeping
 * it here means the test that asserts no select filter is left without options does not have to
 * reach into a UI component to do it.
 *
 * The keys here must cover every entry of `FilterConfig` whose type is 'select'.
 * @param {*} sources the option lists, dynamic ones resolved from props and catalogs from FilterHelper
 */
export const buildFilterDataMap = (sources) => ({
	status: sources.optionsStatus,
	salesRep: sources.representatives,
	provider: sources.serviceProvider,
	customer: sources.allRetailers,
	dispatcher: sources.allInternalUsers,
	techAssigned: sources.allInternalUsers,
	workProcessStatus: sources.workProcessStatusOptions,
	priority: sources.priorityOptions,
	dispatchStatus: sources.dispatchPhaseOptions
})
